import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import materialRequestListAction from './materialRequestList.action.json' with { type: 'json' }
import { materialRequestObject } from '../materialRequestObject'

export const materialRequestExpression = expression(materialRequestObject.shape)

const materialRequestListDefinition = defineAction({
  ...materialRequestListAction,
  input: z.object({
    filter: materialRequestExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      requestDate: 'Data do pedido',
      protocolCode: 'Protocolo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(materialRequestObject),
    count: z.number(),
  }),
})

export default materialRequestListDefinition
